export const LOADING_COMPETENCIES         =     "LOADING_COMPETENCIES";
export const LOADING_COMPETENCIE          =     "LOADING_COMPETENCIE";
export const SAVE_LOADING_COMPETENCIES    =     "SAVE_LOADING_COMPETENCIES";
export const GET_COMPETENCIES             =     "GET_COMPETENCIES";
export const GET_COMPETENCIE              =     "GET_COMPETENCIE";
export const FORM_FAIL                    =     "FORM_FAIL";
export const COMPETENCIES_FAIL            =     "COMPETENCIES_FAIL";
export const COMPETENCIE_FAIL             =     "COMPETENCIE_FAIL";